<!--Refactor: ids needs to be unique-->
<div
  class="table-container body"
  role="table"
  aria-labelledby="ct1-title ct1-header"
>
  <div class="date-range-header">
    <span id="ct1-header" data-testid="analysis-table-date-range">{{
      dateRangeText
    }}</span>
  </div>
  <h4 id="ct1-title" data-testid="analysis-table-header">{{ data.label }}</h4>

  <ng-container *ngIf="!!data.summary">
    <div class="parameter-container">
      <div class="parameter-row" role="row">
        <div class="section-label-group">
          <span
            data-testid="total-parameters-label"
            class="label"
            role="rowheader"
            >{{ data.summaryParameter?.label }}</span
          >
        </div>
        <div
          data-testid="total-parameters-value"
          class="parameter-value"
          role="cell"
        >
          {{ formatSummaryParameter(data.summary) }}
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container
    *ngFor="
      let parameter of data.parameters;
      trackBy: trackByParametersSections
    "
  >
    <div class="parameter-container">
      <div class="parameter-row" role="row">
        <div class="section-label-group">
          <div
            class="spacer"
            [ngClass]="{ 'dashed-border': parameter.axisDashed }"
            [ngStyle]="
              parameter.axisDashed
                ? {
                    background: '#fff',
                    border: '1px dashed ' + parameter.axisColor
                  }
                : { background: parameter.axisColor }
            "
          ></div>
          <div class="image-container">
            <svg-icon
              [src]="assetService.getAssetPath('icons/' + parameter.icon)"
            />
          </div>
          <span
            data-testid="analysis-table-parameter-label"
            class="label"
            role="rowheader"
            >{{ parameter.label }}</span
          >
        </div>
        <div
          data-testid="analysis-table-parameter-value"
          class="parameter-value"
          role="cell"
        >
          {{ formatParameter(parameter) }}
          <span class="day-view-warning" *ngIf="parameter.dayViewOnly">{{
            "DATA_ANALYTICS.PARAMETERS.DAY_VIEW_ONLY_TABLE_WARNING" | translate
          }}</span>
        </div>
      </div>
    </div>
  </ng-container>
</div>
